/**
 * @desc 导出可用PO表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/exportAll`, {
      method: "GET",

      ...options,
    }),
  );
}
